<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">

                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card flat>
                            <v-card-title class="primary white--text headline">
                                Multi Facility Overview
                                <v-spacer></v-spacer>
                                <v-icon  color="green" class="mr-2">fa-map-marker-alt</v-icon> <small>Optimization & FDD</small>
                                <v-icon  color="teal" class="ml-2 mr-2">fa-map-marker-alt</v-icon> <small> Energy Management & FDD</small>
                            </v-card-title>
                            <v-layout row wrap>
                                <v-flex xs12 style="min-height: 700px">
                                    <MglMap
                                            :accessToken="accessToken"
                                            :mapStyle.sync="mapStyle"
                                            :pitch="30"
                                            :zoom="16"
                                            @load="onMapLoaded"
                                            :center="[114.1584, 22.282225]"
                                    >
                                        <MglMarker v-for="facility in facilityPower" :coordinates="facility.coordinates">
                                            <template slot="marker">
                                                <div class="cursor-as-pointer">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <div class="caption text-uppercase" style="text-align:center;position: absolute; top: 50%; left: 50%; transform: translate(-50%, -200%); width:200px;">{{facility.name}}</div>
                                                            <v-icon large v-on="on" :color="facility.featuresType==='Optimization & FDD' ? 'green': 'teal'" @click="openFacilityFromMap(facility.name)">fa-map-marker-alt</v-icon>


                                                        </template>
                                                        <div style="width:600px;" @click="openFacilityFromMap(facility.name)" v-if="facility.featuresType==='Optimization & FDD'">
                                                            <v-layout row wrap>
                                                                <v-flex xs3><v-img :src="facility.thumb" ></v-img>
                                                                    <h2 class="mt-2 mb-2">{{facility.name}}</h2>
                                                                    <h3 class="mt-1 mb-1">{{facility.featuresType}}</h3>

                                                                </v-flex>
                                                                <v-flex xs9>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs7>
                                                                            <value-box :value="facility.totalCurrent" unit="kWh" title="Total Energy" ></value-box>
                                                                            <value-box :value="facility.totalPast" unit="kWh" title="Total Energy Baseline" ></value-box>
                                                                            <value-box :value="Math.abs(facility.powerDiff)" unit="Δ%" title="Total Energy Δ" icon-class="mr-2" v-bind:class="{ 'green-icon': facility.powerDiff<0}" :icon="facility.powerDiff>0 ? 'fa-long-arrow-alt-up': 'fa-long-arrow-alt-down'" ></value-box>
                                                                            <value-box  :value="Math.abs(facility.co2)" use-int unit="ΔkgCO2e" title="Carbon Emissions Δ" icon-class="mr-2" v-bind:class="{ 'green-icon': facility.powerDiff<0}" :icon="facility.powerDiff>0 ? 'fa-long-arrow-alt-up': 'fa-long-arrow-alt-down'"></value-box>
                                                                            <value-box  :value="Math.abs(facility.trees)" use-int title="Equivalent Trees Δ" icon-class="mr-2" v-bind:class="{ 'green-icon': facility.powerDiff<0}" :icon="facility.powerDiff>0 ? 'fa-long-arrow-alt-up': 'fa-long-arrow-alt-down'"></value-box>
                                                                        </v-flex>
                                                                        <v-flex xs5 v-if="faultMetrics">
                                                                            <value-box :value="faultMetrics[facility.name].total" use-int title="Total Faults Detected"></value-box>
                                                                            <value-box v-for="(value,key) in faultMetrics[facility.name].breakdown" v-if="value>0" :value="value" use-int :title="key+' Faults'"></value-box>

                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>

                                                        </div>
                                                        <div style="width:600px;" @click="openFacilityFromMap(facility.name)" v-if="facility.featuresType==='Energy Management & FDD'">
                                                            <v-layout row wrap>
                                                                <v-flex xs3><v-img :src="facility.thumb" ></v-img>
                                                                    <h2 class="mt-2 mb-2">{{facility.name}}</h2>
                                                                    <h3 class="mt-1 mb-1">{{facility.featuresType}}</h3>

                                                                </v-flex>
                                                                <v-flex xs9>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs7>
                                                                            <value-box :value="facility.totalCurrent+facility.totalPast" unit="kWh" title="Total Managed Energy" ></value-box>
                                                                            <value-box v-if="faultMetrics" :value="faultMetrics[facility.name].total" use-int title="Total Faults Detected"></value-box>
                                                                        </v-flex>
                                                                        <v-flex xs5 v-if="faultMetrics">
                                                                            <value-box v-for="(value,key) in faultMetrics[facility.name].breakdown" v-if="value>0" :value="value" use-int :title="key+' Faults'"></value-box>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>

                                                        </div>

                                                    </v-tooltip>

                                                </div>
                                            </template>
                                        </MglMarker>
                                    </MglMap>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs2 v-for="facility in facilityPower" v-on:click="panTo(facility.coordinates)">
                                    <value-box icon="fa-map-marker-alt" icon-size="26" icon-class="mr-2 green--text" v-if="facility.featuresType==='Optimization & FDD'" :value="facility.savingKW" unit="kWh savings" :title="facility.name" class="cursor-as-pointer" ></value-box>
                                    <value-box icon="fa-map-marker-alt" icon-size="26" icon-class="mr-2 teal--text" v-if="faultMetrics&&facility.featuresType==='Energy Management & FDD'" :value="faultMetrics[facility.name].total" unit="faults" use-int :title="facility.name" class="cursor-as-pointer" ></value-box>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs6 md3>
                                    <vue-plotly v-if="energyPieData" disable-responsive :data="energyPieData"
                                                @click="openFacilityEnergyFromPie"
                                                :layout="energyPieLayout" :options="{}"/>
                                </v-flex>
                                <v-flex xs6 md3>
                                    <vue-plotly v-if="faultPieData" disable-responsive :data="faultPieData"
                                                @click="openFacilityFaults"
                                                :layout="faultPieLayout" :options="{}"/>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <vue-plotly v-if="energyPerFacilityData" disable-responsive :data="energyPerFacilityData"
                                                @click="openFacilityEnergyFromPlot"
                                                :layout="energyPerFacilityLayout" :options="{}"/>
                                </v-flex>
                            </v-layout>
                            <v-card-title class="primary white--text headline">
                                Optimization Highlights
                            </v-card-title>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-data-table
                                            :headers="optimizationHeaders"
                                            disable-initial-sort
                                            :items="optimizations"
                                            :rows-per-page-items="[10,20,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                    >
                                        <template v-slot:items="props">
                                            <td class="text-xs-left">{{ props.item.facility }}</td>
                                            <td class="text-xs-left">{{ props.item.savingPercentage}}%</td>
                                            <td class="text-xs-left">{{ props.item.savingKW}}kWh</td>
                                            <td class="text-xs-left">{{ props.item.savingCO2 }}kgCO2e</td>
                                            <td class="text-xs-left">{{props.item.savingTrees}}</td>
                                            <td class="text-xs-left">
                                                <v-icon
                                                        small
                                                        @click="jumpToOptimizationLink(props.item)"
                                                >
                                                    fa-chart-line
                                                </v-icon>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                            <v-card-title class="primary white--text headline">
                                FDD Highlights
                            </v-card-title>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-data-table
                                            :headers="headers"
                                            disable-initial-sort
                                            :items="faults"
                                            :rows-per-page-items="[10,20,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                    >

                                        <template v-slot:items="props">
                                            <td class="text-xs-left">{{ props.item.title }}</td>
                                            <td class="text-xs-left">{{ props.item.facility }}</td>
                                            <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                                            <td class="text-xs-left">{{props.item.start_date}}</td>
                                            <td class="text-xs-left">{{props.item.end_date}}</td>
                                            <td class="text-xs-left">
                                                <v-icon
                                                        small
                                                        @click="jumpToFaultLink(props.item)"
                                                >
                                                    fa-chart-line
                                                </v-icon>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>

                        </v-card>
                    </v-flex>
                </v-layout>
        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {callAPI} from '@/helper'
    import moment from 'moment'
    import Mapbox from "mapbox-gl";
    import { MglMap,MglMarker } from "vue-mapbox";
    import ValueBox from "../components/ValueBox";

export default {
  name: 'FacilityOverview2',
  components: {VuePlotly,MglMap,MglMarker,ValueBox},
    created() {
        this.mapbox = Mapbox;
    },
    computed:{

    },
  data () {
      return {
          severityColors:{
              critical:'rgb(148, 103, 189)',
              low:'rgb(188, 189, 34)',
              medium:'rgb(255, 127, 14)',
              high:'rgb(214, 39, 40)',
          },
          accessToken: "pk.eyJ1IjoiYWxleGRvYnJlIiwiYSI6ImNrN3BtZHZxcTAyMGwzcmwyaDA1cnR0ODMifQ.qUYFNvUiAyO9XaM_vRajWw",
          mapStyle: "mapbox://styles/alexdobre/ck7zqwh9i2e681intld6eat26",
          baseDate:  moment().subtract(8, "days"),
          endDate:  moment().subtract(1, "days"),
          plantCOP:null,
          totalCP:null,
          headers: [
              {
                  text: 'Issue',
                  align: 'left',
                  sortable: true,
                  value: 'title'
              },
              {text: 'Facility', value: 'facility'},
              {text: 'Equipment', value: 'equipment_name'},
              {text: 'Start Date', value: 'start_date'},
              {text: 'End Date', value: 'end_date'},
              {text: 'Actions', value: 'name', sortable: false}
          ],
          optimizationHeaders: [
              {
                  text: 'Facility',
                  align: 'left',
                  sortable: true,
                  value: 'facility'
              },

              {text: 'Saving Percentage', value: 'savingPercentage'},
              {text: 'Saving After Optimisation', value: 'savingKW'},
              {text: 'Carbon Emissions Saved', value: 'savingCO2'},
              {text: 'Equivalent Trees Planted', value: 'savingTrees'},

              {text: 'Actions', value: 'name', sortable: false}
          ],
          optimizations:[{
              facility: "MTR SHT",
              savingPercentage:11.63,
              savingKW:20352,
              savingCO2:10380,
              savingTrees:794,
              link:'/overview'
          },{
              facility: "MTR CRP",
              savingPercentage:8.623,
              savingKW:53708,
              savingCO2:27391,
              savingTrees:2094,
              link:'/overview'
          },{
              facility: "Exchange Square",
              savingPercentage:4.623,
              savingKW:'-- ',
              savingCO2:'-- ',
              savingTrees:'-- ',
              link:'/optimizationsaving'
          }
          ],
          faults:[
              {
                  title:"CO2 Anomaly",
                  facility:"Exchange Square",
                  equipment_name:"21F_AHU",
                  start_date:"2020-02-28",
                  end_date:"2020-03-13",
                  link:"https://hkl-es.jec-digital.com/modelsummary?rangeStart=2020-02-28%2017%3A45%3A00&rangeEnd=2020-03-13%2018%3A45%3A00&equipment=21F_AHU"
              },
              {
                  title:"AHU Space Temp greater than 30 Deg C for a period of 2 hours or more when AHU is running",
                  facility:"HKIA",
                  equipment_name:"AHU5102",
                  start_date:"2018-09-19",
                  end_date:"2018-09-20",
                  link:"https://hkaa-t1.jec-digital.com/fault-analysis?relevantVariables=Space_Temp&faultName=AHU%20Space%20Temp%20greater%20than%2030%20Deg%20C%20for%20a%20period%20of%202%20hours%20or%20more%20when%20AHU%20is%20running&faultDesc=AHU%20Space%20Temp%20greater%20than%2030%20Deg%20C%20for%20a%20period%20of%202%20hours%20or%20more%20when%20AHU%20is%20running&rangeStart=2018-09-19%2020%3A06%3A00&rangeEnd=2018-09-20%2023%3A54%3A00&equipmentName=AHU5102"
              },
              {
                  title:"AHU Space Temp Anomaly",
                  facility:"HKIA",
                  equipment_name:"AHU5102",
                  start_date:"2018-09-16",
                  end_date:"2018-09-20",
                  link:"https://hkaa-t1.jec-digital.com/modelsummary?rangeStart=2018-09-16%2012%3A00%3A00&rangeEnd=2018-09-20%2018%3A00%3A00&equipment=AHU5104"
              },
              {
                  title:"OA Damper Control Changes rapidly",
                  facility:"HKIA",
                  equipment_name:"AHU5213",
                  start_date:"2018-08-30",
                  end_date:"2018-09-20",
                  link:"https://hkaa-t1.jec-digital.com/fault-analysis?relevantVariables=OA_Damper_Control&faultName=AHU%20OA%20Damper%20control%20changes%20greater%20than%2020%25%20within%2020%20minutes&faultDesc=AHU%20OA%20Damper%20control%20changes%20rapidly%20within%2060%20minutes%20when%20AHU%20is%20running&rangeStart=2018-08-30%2005%3A06%3A00&rangeEnd=2018-09-20%2023%3A54%3A00&equipmentName=AHU5213"
              },
              {
                  title:"Chilled Water Flow when chiller is off",
                  facility:"Exchange Square",
                  equipment_name:"Chiller5",
                  start_date:"2020-03-14",
                  end_date:"2020-03-16",
                  link:"https://hkl-es.jec-digital.com/fault-analysis?relevantVariables=Running_Status,CHW_Flowrate&faultName=Chilled%20Water%20Flow%20across%20chiller%20evaporator%20when%20chiller%20is%20off&faultDesc=Chilled%20Water%20Flow%20Rate%20on%20chiller%20evaporator%20%3E%2010%20L%2Fs%20when%20chiller%20is%20OFF%20for%20a%20period%20of%202%20hours%20or%20more&rangeStart=2020-03-14%2000%3A45%3A00&rangeEnd=2020-03-16%2007%3A30%3A00&equipmentName=Chiller5"
              },
              {
                  title:"Chiller Short cycling",
                  facility:"MTR SHT",
                  equipment_name:"ACPC-1",
                  start_date:"2019-12-07",
                  end_date:"2019-12-14",
                  link:"https://mtr-sht.jec-digital.com/fault-analysis?relevantVariables=Comp_Power,Running_Status&faultName=Chiller%20Short%20Cycling&faultDesc=Chiller%20turning%20on%20and%20off%20within%2030%20minutes%20interval%20&rangeStart=2019-12-07%2020%3A00%3A00&rangeEnd=2019-12-14%2010%3A30%3A00&equipmentName=ACPC-1"
              },
              {
                  title:"Chiller Overcooling",
                  facility:"MTR SHT",
                  equipment_name:"ACPC-2",
                  start_date:"2019-09-28",
                  end_date:"2019-09-28",
                  link:"https://mtr-sht.jec-digital.com/fault-analysis?relevantVariables=CHWS_Temp&faultName=Chiller%20overcooling%20%28CHWST%20less%20than%204%20Deg%20C%29&faultDesc=Chilled%20Water%20Supply%20Temperature%20less%20than%204%20Deg%20C%20for%20a%20period%20of%201%2F2%20hour%20or%20more%20when%20Chiller%20is%20running&rangeStart=2019-09-28%2017%3A45%3A00&rangeEnd=2019-09-28%2017%3A45%3A00&equipmentName=ACPC-2"
              },
              {
                  title:"Chilled Water Flow when chiller is off",
                  facility:"MTR CRP",
                  equipment_name:"Chiller1",
                  start_date:"2019-12-19",
                  end_date:"2019-12-19",
                  link:"https://mtr-crp.jec-digital.com/fault-analysis?relevantVariables=Flow_Rate&faultName=Chilled%20Water%20Flow%20across%20chiller%20evaporator%20when%20chiller%20is%20off&faultDesc=Chilled%20Water%20Flow%20Rate%20on%20chiller%20evaporator%20%3E%2010%20L%2Fs%20when%20chiller%20is%20OFF%20for%20a%20period%20of%202%20hours%20or%20more&rangeStart=2019-12-19%2009%3A00%3A00&rangeEnd=2019-12-19%2013%3A30%3A00&equipmentName=Chiller1"
              }
          ],
          powerDiff:null,
          faultMetrics:null,
          mapActions:null,
          notifTraces:null,
          dateRange:  {start:moment().subtract(8, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
          loading:true,
          facilityPower:[],
          facilityList:{
              "MTR SHT":{
                  featuresType:"Optimization & FDD",
                  endpoint:"https://mtr-demo-sht-dot-pdm-229904.appspot.com",
                  facilityName:"SHT",
                  energyPage:"/energy-trend",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  customPowerVars:["Comp_Power"],
                  customRange:["2020-01-14 00:00:00", "2020-01-21 23:59:59"],
                  customPastRange:["2020-01-07 00:00:00", "2020-01-13 23:59:59"],
                  thumb:require('@/assets/img/300px-Sha_Tin_Station_Platform_2011.jpg'),
                  coordinates: [114.1875, 22.3825],
                  feBase:"https://mtr-sht.jec-digital.com",
                  overrides:{
                      totalCurrent:154690,
                      totalPast:175042,
                      powerDiff:11.63,
                      savingKW:20352,
                      co2:10380,
                      trees:794,
                  }
              },
              "MTR CRP":{
                  featuresType:"Optimization & FDD",
                  endpoint:"https://mtr-demo-crp-dot-pdm-229904.appspot.com",
                  facilityName:"CRP",
                  energyPage:"/energy-trend",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  customPowerVars:["Comp_Power"],
                  customRange:["2020-01-14 00:00:00", "2020-01-21 23:59:59"],
                  customPastRange:["2020-01-07 00:00:00", "2020-01-13 23:59:59"],
                  thumb:require('@/assets/img/crp.jpg'),
                  coordinates: [114.1563, 22.3354],
                  feBase:"https://mtr-crp.jec-digital.com",
                  overrides:{
                      totalCurrent:569114,
                      totalPast:622822,
                      powerDiff:8.623,
                      savingKW:53708,
                      co2:27391,
                      trees:2094,
                  }
              },
              "Exchange Square":{
                  featuresType:"Energy Management & FDD",
                  endpoint:"https://es-demo-dot-pdm-229904.appspot.com",
                  facilityName:"ES",
                  energyPage:"/hkl-energy",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  thumb:require('@/assets/img/200px-HK_Exchange_Square.jpg'),
                  coordinates: [114.158333, 22.283889],
                  feBase:"https://hkl-es.jec-digital.com"
              },
              "HKIA":{
                  featuresType:"Energy Management & FDD",
                  endpoint:"https://aa-demo-dot-pdm-229904.appspot.com",
                  facilityName:"AA",
                  energyPage:"/overview",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  thumb:require('@/assets/img/hkia-5.jpg'),
                  customRange:["2018-09-12 00:00:00", "2018-09-19 23:59:59"],
                  customPastRange:["2018-09-04 00:00:00", "2018-09-11 23:59:59"],
                  coordinates: [113.914444, 22.308889],
                  feBase:"https://hkaa-t1.jec-digital.com"
              },
              "Chater House":{
                  featuresType:"Energy Management & FDD",
                  endpoint:"https://ch-demo-dot-pdm-229904.appspot.com",
                  thumb:require('@/assets/img/200px-HK_Chater_House.jpg'),
                  energyPage:"/hkl-energy",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  facilityName:"CH",
                  coordinates: [114.1584, 22.282225],
                  feBase:"https://hkl-ch.jec-digital.com"
              },
              "Prince's Building":{
                  featuresType:"Energy Management & FDD",
                  thumb:require('@/assets/img/200px-HK_Princes_Building.jpg'),
                  endpoint:"https://pb-demo-dot-pdm-229904.appspot.com",
                  energyPage:"/hkl-energy",
                  notifPage:"/notification-breakdown",
                  overviewPage:"/overview",
                  facilityName:"PB",
                  coordinates: [114.15933, 22.28124],
                  feBase:"https://hkl-pb.jec-digital.com"
              }
          },
          energyPieData:null,
          faultPieData:null,
          faultPieLayout:{
              title:"Faults Site Breakdown",
              legend: {
                  orientation: 'h',
                  y:-0.3
              },
          },
          energyPieLayout:{
              title:"Total Energy Site Breakdown",
              legend: {
                  orientation: 'h',
                  y:-0.3
              },

          },
          energyPerFacilityData:null,
          energyPerFacilityLayout:{
              title:"Energy Consumption (kWh)",
              grid: {rows: 2, columns: 3, pattern: 'independent'},
              bargap: 0.2,
              bargroupgap: 0.2,
              showlegend:false,
          },
          faultsPerFacilityData:null,
          faultsPerFacilityLayout:{
              title:"Faults Summary",
              legend: {
                  orientation: 'h',
                  y:-0.3
              },
              barmode: 'group'
          },


      }
  },
    methods:{
        jumpToOptimizationLink(item){
            let pass = localStorage.getItem('pass');
            let output = {
                path: item.link,
                query: {
                    token: pass
                }
            }
            window.open(this.facilityList[item.facility].feBase+this.$router.resolve(output).href)
        },
        jumpToFaultLink(item) {
            let pass = localStorage.getItem('pass');
            window.open(item.link+"&token="+pass)
        },
        onMapLoaded(event) {
            this.mapActions =  event.component.actions;
        },
        addArrays(ar1, ar2){
            let ar3 = [];
            for(let i in ar1)
                ar3.push(ar1[i] + ar2[i]);
            return ar3;
        },
        openFacilityEnergyFromPie(data){
            let pass = localStorage.getItem('pass');
            window.open(this.facilityList[data.points[0].label].feBase+this.facilityList[data.points[0].label].energyPage+"?token="+pass, '_blank');
        },
        openFacilityFaults(data){
            let pass = localStorage.getItem('pass');
            window.open(this.facilityList[data.points[0].label].feBase+this.facilityList[data.points[0].label].notifPage+"?token="+pass, '_blank');
        },
        panTo(coords){
            this.mapActions.panTo(coords,{duration:4000})
        },
        openFacilityEnergyFromPlot(data){
            let pass = localStorage.getItem('pass');
            window.open(this.facilityList[data.points[0].x].feBase+this.facilityList[data.points[0].x].energyPage+"?token="+pass, '_blank');
        },
        openFacilityFromMap(facility){
            let pass = localStorage.getItem('pass');
            window.open(this.facilityList[facility].feBase+this.facilityList[facility].overviewPage+"?token="+pass, '_blank');
        },
        getData(){
            let me=this;
            me.loading=true
            let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
            let pastRange=[moment(currentRange[0]).subtract(7, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment(currentRange[1]).subtract(7, "days").endOf('day').format('YYYY-MM-DD HH:mm:ss')]
            let currentPowerPromisses=[]
            let pastPowerPromisses=[]
            let notifPromises=[]
            for (let facility in me.facilityList){
                let apiBaseUrl=me.facilityList[facility].endpoint
                currentPowerPromisses.push(callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.facilityList[facility].facilityName,
                            'sensor_names': me.facilityList[facility].customPowerVars ? me.facilityList[facility].customPowerVars : ["Power"],
                            'date_range':me.facilityList[facility].customRange ? me.facilityList[facility].customRange : currentRange,
                        },
                        "pipeline": [
                            {"type": "agg_h", "agg_op": "sum"},
                            {"type": "agg", "agg": "D", "agg_op": "sum"}
                        ],
                        "apiBaseUrl":apiBaseUrl,
                        "mfTagFacility":facility
                    }
                ))
                pastPowerPromisses.push(callAPI('data2/',
                    {
                        'filters': {
                            'facility_name': me.facilityList[facility].facilityName,
                            'sensor_names': me.facilityList[facility].customPowerVars ? me.facilityList[facility].customPowerVars : ["Power"],
                            'date_range':me.facilityList[facility].customPastRange ? me.facilityList[facility].customPastRange : pastRange,
                        },
                        "pipeline": [
                            {"type": "agg_h", "agg_op": "sum"},
                            {"type": "agg", "agg": "D", "agg_op": "sum"}
                        ],
                        "apiBaseUrl":apiBaseUrl,
                        "mfTagFacility":facility
                    }
                ))
                notifPromises.push(callAPI('notification/',{
                    facility_name: me.facilityList[facility].facilityName,
                    apiBaseUrl:apiBaseUrl,
                    date_range:null,
                    mfTagFacility:facility
                }))
            }
            Promise.all(notifPromises).then(function (notifReses) {
                let faultMetrics={}
                let facilityNames=[]
                let facilityFaults=[]
                for (let notifRes of notifReses) {
                    let rangeFaults = notifRes.data.result
                    let facility = JSON.parse(notifRes.config.data)["mfTagFacility"]
                    facilityNames.push(facility)
                    facilityFaults.push(rangeFaults.length)
                    faultMetrics[facility] = {
                        total: rangeFaults.length,
                        breakdown: {
                            'Chiller': rangeFaults.filter(x => x.equipment_type.toLowerCase().startsWith('chiller')).length,
                            'Pump': rangeFaults.filter(x => x.equipment_type.toLowerCase().endsWith('water_pump')).length,
                            'VAV': rangeFaults.filter(x => x.equipment_type === "VAV").length,
                            'AHU': rangeFaults.filter(x => x.equipment_type === "ECFAN" || x.equipment_type === "AHU").length,
                            'PAU': rangeFaults.filter(x => x.equipment_type === "PAU").length,
                            'Cooling Tower': rangeFaults.filter(x => x.equipment_type === "COOLING_TOWER").length,
                        }
                    }
                }
                me.faultMetrics=faultMetrics
                me.faultPieData=[
                    {
                        type: 'pie',
                        hole: .7,
                        labels: facilityNames,
                        sort:false,
                        values: facilityFaults
                    }
                ]
            })
            Promise.all(currentPowerPromisses).then(function (reses) {
                let power={}
                let timestamp=null
                for (let res of reses) {
                    let facility = JSON.parse(res.config.data)["mfTagFacility"]
                    if (!timestamp && res.data.timestamp) {
                        timestamp = res.data.timestamp;
                    }
                    let powerForThis =res.data['sum'] ?  res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq) : [0]
                    if (!power[facility]) {
                        power[facility] = {
                            name: facility,
                            coordinates:me.facilityList[facility].coordinates,
                            thumb:me.facilityList[facility].thumb,
                            feBase:me.facilityList[facility].feBase,
                            featuresType:me.facilityList[facility].featuresType
                        }
                    }
                    power[facility].current=powerForThis
                    power[facility].totalCurrent=powerForThis.reduce((sum, x) => sum + x,0)
                }
                Promise.all(pastPowerPromisses).then(function (reses) {
                    for (let res of reses) {
                        let facility = JSON.parse(res.config.data)["mfTagFacility"]
                        let powerForThis = res.data['sum'] ? res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq) : [0]
                        if(!power[facility]){
                            power[facility]={
                                name:facility
                            }
                        }
                        power[facility].past=powerForThis
                        power[facility].totalPast=powerForThis.reduce((sum, x) => sum + x,0)
                    }
                    let facilityNames=[]
                    let facilityCP=[]
                    let facilityPP=[]
                    for (let index in power){
                        let item=power[index]
                        facilityNames.push(item.name)
                        if(me.facilityList[item.name].overrides){
                            Object.assign(item,me.facilityList[item.name].overrides)
                        }
                        item.powerDiff=-((item.totalPast-item.totalCurrent)/item.totalPast)*100
                        item.co2=-(item.totalPast-item.totalCurrent)*0.51
                        item.trees=Math.round(-(item.totalPast-item.totalCurrent)*0.039)
                        facilityCP.push(item.totalCurrent)
                        facilityPP.push(item.totalPast)
                    }
                    me.energyPieData=[
                        {
                            type: 'pie',
                            hole: .7,
                            labels: facilityNames,
                            sort:false,
                            values: facilityCP
                        }
                    ]
                    let epfdata=[];
                    for (let nameIndex in facilityNames){
                        let comp1={
                            x:[facilityNames[nameIndex]],
                            y:[facilityCP[nameIndex]],
                            width:[0.2],
                            name:"Energy",
                            marker: {
                                color: 'rgb(31, 119, 180)',
                                width:0.2
                            },
                            type: 'bar',
                        }
                        let comp2={
                            x:[facilityNames[nameIndex]],
                            y:[facilityPP[nameIndex]],
                            width:[0.2],
                            name:"Baseline",
                            marker: {
                                color: 'rgb(255, 127, 14)',
                                width:0.2
                            },
                            type: 'bar',
                        }
                        if(nameIndex>0){
                            let jscantcount=parseInt(nameIndex)+1 //would be interesting to find out how nameIndex array key actually managed to become a string : js engine broken?
                            comp1.xaxis='x'+String(jscantcount)
                            comp2.xaxis='x'+String(jscantcount)
                            comp1.yaxis='y'+String(jscantcount)
                            comp2.yaxis='y'+String(jscantcount)
                        }
                        epfdata.push(comp1)
                        epfdata.push(comp2)

                    }
                    me.energyPerFacilityData=epfdata
                    me.facilityPower=Object.values(power);
                    me.loading=false;
                })
            })





        }
    },
    beforeMount() {
        let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
        if(maxDate){
            this.baseDate=moment(maxDate).subtract(8, "days")
            this.endDate=moment(maxDate).subtract(1, "days")
            this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
        }
        this.getData();
    }


}
</script>

<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
    .green-icon .theme--dark.v-icon{
        color: #77C16B;
    }
    .green-thing{
        color: #77C16B;
    }
</style>
